import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// import '../../assets/css/playvideo.css';
import { t } from 'i18next';

const ViewMoreVideos = () => {
  const location = useLocation();
  const { videos } = location.state || {};
  const navigate = useNavigate();
  const handleBackClick = () => {
    navigate(-1); // Redirects to the home page
  };
  const handlePlayVideo=(video)=>
  {
    const filteredVideos = videos.filter((v) => v !== video); // Exclude the current video
    navigate('/play-video', { state: { video, relatedVideos: filteredVideos } });
  }

  return (
    <>

      <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
        <button className="win-back-btn" onClick={handleBackClick}><span><i class='bi bi-chevron-left'></i> {t('back')}</span></button>
        <h2 className="page-heading">{t("All Videos")}</h2>
      </div>

      
          {videos && videos.length > 0 ? (
            <div className="all-videos-listt">
              {videos.map((video, index) => (
                <div
                  key={index}
                  className="all-videos-list-item-wrapper"
                  onClick={() => handlePlayVideo(video)}
                >
                  <div className="all-videos-list-item-thumb-wrapper">
                    <img
                      src={video.image}
                      alt={video.name || 'Video Thumbnail'}
                      className="all-videos-list-item-thumbnail"
                    />
                    <div className="play-button">
                      <i className="bi bi-play-fill"></i>
                    </div>
                  </div>
                  
                  <div className="all-videos-list-video-info-wrapper">
                    <h4 className="all-videos-list-video-title">{video.name}</h4>
                    <span className="video-play-time">{video.runtime}</span>
                  </div>
                  
                </div>
              ))}
            </div>
          ) : (
            <p className="no-videos-message">No videos available.</p>
          )}
        
    </>
  
  );
};

export default ViewMoreVideos;
